import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { parseDate } from '~/eds/src/utils/parseDate';
import { withFlags } from '~/flags/withFlags';
import { injectIntl } from 'react-intl';
import { withFormatDate } from '~/i18n/hocs/withFormatDate';
import Text from '~/ui/components/Text/Text';

import {
  MODAL_ADMIN_USER,
  MODAL_DELETE,
  MODAL_SEND_EMAIL,
} from '../../../types/modal.types';
import ActionsMenu from '../ActionsMenu/ActionsMenu';
import styles from './EcUserItem.styles';

class EcUserItem extends Component {
  renderExtraOptions(item) {
    const { classes, handleShowModal, intl } = this.props;
    const getMenuItems = () => {
      const items = [];

      items.push({
        content: intl.formatMessage({
          id: 'EcUserItem.editUser',
          defaultMessage: 'Edit User',
          description: 'Menu item to edit user',
        }),
        onClick: () => handleShowModal(MODAL_ADMIN_USER, true, item),
      });

      items.push({
        content: intl.formatMessage({
          id: 'EcUserItem.sendPasswordLink',
          defaultMessage: 'Send Link to Set New Password',
          description: 'Menu item to send password reset link',
        }),
        onClick: () => handleShowModal(MODAL_SEND_EMAIL, false, item),
      });

      items.push({
        content: intl.formatMessage({
          id: 'EcUserItem.deleteUser',
          defaultMessage: 'Delete User',
          description: 'Menu item to delete user',
        }),
        onClick: () => handleShowModal(MODAL_DELETE, false, item),
      });

      return items;
    };

    return (
      <div className={classes.actionsWrapper}>
        <ActionsMenu
          id={`party_item_actions_menu?id=${item.name}`}
          items={getMenuItems()}
          align="end"
          title={intl.formatMessage({
            id: 'EcUserItem.actionsMenuTitle',
            defaultMessage: 'party item actions menu',
            description: 'Accessibility title for user actions menu',
          })}
        />
      </div>
    );
  }

  render() {
    const { item, formatDate } = this.props;

    return (
      <tr>
        <td>{item.email}</td>
        <td>{`${item.firstName} ${item.lastName}`}</td>
        <td>
          {formatDate(
            item.lastLogin ? parseDate(item.lastLogin) : null,
            'short_datetime',
          )}
        </td>
        <td>
          <Text variant="m-dense" shouldTruncate={true}>
            {item.positionName}
          </Text>
        </td>
        <td>
          {item.departmentsSelected
            .map((dept) => dept.department_name)
            .join(' • ')}
        </td>
        <td>{item.jobTitle}</td>
        <td>{this.renderExtraOptions(item)}</td>
      </tr>
    );
  }
}

EcUserItem.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  handleShowModal: PropTypes.func,
  intl: PropTypes.object.isRequired,
};

export default injectSheet(styles)(
  injectIntl(withFlags(withFormatDate(EcUserItem))),
);
